import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Input, { Label } from './index'
import { ErrorWrapper, Error } from '../Errors'

const EmailInput = ({ name, label, placeholder, onChange, onBlur, errors, errorMessage, defaultValue, ...props }) => (
  <Fragment>
    <Label>{label}</Label>
    <Input
      type="email"
      name={name}
      value={defaultValue}
      placeholder={placeholder}
      onChange={onChange}
      onBlur={onBlur}
      errors={errors}
      {...props}
    />
    {errors && (
      <ErrorWrapper>
        <Error color="red">{errorMessage}</Error>
      </ErrorWrapper>
    )}
  </Fragment>
)

EmailInput.propTypes = {
  defaultValue: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  errors: PropTypes.bool,
  errorMessage: PropTypes.string,
}

EmailInput.defaultProps = {
  errors: false,
  errorMessage: '',
  defaultValue: '',
  onBlur: () => {},
}

export default EmailInput
